module.exports = __webpack_public_path__ + "static/media/method-3c.8c54db80.png";